import { procesosService } from "@/_services";

export const procesos = {
  namespaced: true,
  state: {
    entity: {
      data: {},
      status: {},
    },
    list: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getByIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getByIdError(state, error) {
      state.entity.data = {};
      state.entity.status = {
        error,
      };
    },
    getByIdSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
    getListRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getListError(state, error) {
      state.list.data = [];
      state.list.status = {
        error,
      };
    },
    getListSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
  },
  actions: {
    getList({ commit }, req) {
      commit("getListRequest");
      procesosService
        .getList(req.pagination, req.filters)
        .then((response) => {
          commit("getListSuccess", response);
        })
        .catch((error) => {
          commit("getListError", error);
        });
    },
    getById({ commit }, idOtros) {
      commit("getByIdRequest");
      procesosService
        .getById(idOtros)
        .then((response) => {
          commit("getByIdSuccess", response);
        })
        .catch((error) => {
          commit("getByIdError", error);
        });
    },
  },
};
